function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M13.1,8.4c-0.2-0.5-0.5-0.9-0.8-1.2C12,6.9,11.5,6.6,11,6.4S9.9,6.1,9.3,6.1H8.5H7.8H6.6v7.7h1.2h0.7h0.8 c0.6,0,1.2-0.1,1.7-0.3s0.9-0.4,1.3-0.8c0.4-0.3,0.6-0.7,0.8-1.2c0.2-0.5,0.3-1,0.3-1.6C13.4,9.4,13.3,8.9,13.1,8.4z M11.3,11 c-0.1,0.3-0.3,0.5-0.5,0.7s-0.4,0.3-0.7,0.4c-0.3,0.1-0.6,0.1-0.8,0.1H8.5V7.8h0.8c0.3,0,0.6,0,0.8,0.1s0.5,0.2,0.7,0.4 C11,8.5,11.2,8.7,11.3,9c0.1,0.3,0.2,0.6,0.2,1C11.5,10.4,11.4,10.8,11.3,11z"
});

var SvgD = function SvgD(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/D.d3da8566.svg";
export { ForwardRef as ReactComponent };